import React from 'react';

import { ActionButton } from '../../../common';

const CombineProfileLayout = ({ data, handleSubmit, handleCloseModal }) => {
  return (
    <>
      <div className="modal-header d-i p-b-0 text-center">
        <h2>Объединяемые анкеты</h2>
      </div>
      <div className="modal-body">
        <table className="table hover">
          <thead>
            <tr>
              <th scope="col">
                <p>ФИО</p>
              </th>
              <th scope="col">
                <p>Идентификационный номер</p>
              </th>
              <th scope="col">
                <p>Документы</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map(({ id, fullName, personal, doc }) => {
                return (
                  <tr key={id}>
                    <td>
                      <p>{fullName}</p>
                    </td>
                    <td>
                      <p>{personal}</p>
                    </td>
                    <td>
                      {doc.map((i, idx) => (
                        <p key={i.documentNumber + idx}>
                          {i.active && <span className="font-bold">Активен</span>}
                          {`${i.active ? '' : 'Неактивен'}: ${i.documentType} №${
                            i.documentNumber
                          }, ${i.country}`}
                        </p>
                      ))}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className="modal-footer overestimation-modal-footer">
        <ActionButton text="Сохранить" styleName="button" func={handleSubmit} />
        <ActionButton text="Отменить" styleName="button-light" func={handleCloseModal} />
      </div>
    </>
  );
};

export default CombineProfileLayout;
